import { useState } from "react"
import { FiX, FiMapPin } from "react-icons/fi"
import Modal from "../../../shared/modal/Modal"
import Button from "../../../shared/components/Button/Button"
import Generator from "../Generator"
import GeneratorLocationModal from "./GeneratorLocationModal"
import { describeLocation } from "../../../utils/generatorLocation"
import "./SelectGenerators.css"

const SAME_AS_CLIENT = { sameAsClient: true }

function SelectGenerators({ data, dataArray, btCancelAction, handleOnSave, readOnly }) {

    const [modalGenerators, setModalGenerators] = useState(false)
    const [generators, setGenerators] = useState(dataArray || [])

    // Geradores recém-escolhidos esperando a resposta "mesmo endereço do cliente?", um de cada vez.
    const [askQueue, setAskQueue] = useState([])
    // Gerador já vinculado cujo endereço está sendo editado pelo ícone da linha.
    const [editingId, setEditingId] = useState(null)

    const currentId = editingId || askQueue[0] || null
    const currentGenerator = generators.find((g) => g._id === currentId)

    const removeItem = (item) => {
        setGenerators(generators.filter((g) => g._id !== item._id))
        setAskQueue((queue) => queue.filter((id) => id !== item._id))
    }

    const handleOnSelectItemGenerator = (selected) => {
        const alreadyHere = new Set(generators.map((g) => g._id))
        const added = selected.filter((g) => !alreadyHere.has(g._id)).map((g) => g._id)
        setGenerators(selected)
        setAskQueue((queue) => [...queue.filter((id) => selected.some((g) => g._id === id)), ...added])
    }

    const setLocation = (id, location) => {
        setGenerators((list) => list.map((g) => (g._id === id ? { ...g, location } : g)))
    }

    const finishQuestion = (location) => {
        if (currentId) setLocation(currentId, location)
        if (editingId) setEditingId(null)
        else setAskQueue((queue) => queue.slice(1))
    }

    // Fechar sem confirmar: gerador novo fica com "mesmo do cliente"; edição não muda nada.
    const dismissQuestion = () => {
        if (editingId) { setEditingId(null); return }
        if (currentId) setLocation(currentId, SAME_AS_CLIENT)
        setAskQueue((queue) => queue.slice(1))
    }

    const save = () => {
        handleOnSave(generators.map((g) => ({ ...g, location: g.location || SAME_AS_CLIENT })))
    }

    return (
        <section className="sg-page">

            <div className="sg-header">
                <div className="sg-header-title">
                    <p className="sg-title">{data.name}</p>
                    <span className="sg-title-accent" />
                </div>
                <div className="sg-header-actions">
                    {!readOnly && <Button variant="save" onClick={save}>Salvar</Button>}
                    {!readOnly && <Button variant="select" onClick={() => setModalGenerators(true)}>Selecionar</Button>}
                    <Button variant="cancel" onClick={() => btCancelAction()}>{readOnly ? 'Fechar' : 'Cancelar'}</Button>
                </div>
            </div>

            <p className="sg-subtitle">Geradores vinculados</p>

            <div className="sg-list">
                {generators && generators.length > 0 ? (
                    generators.map((item) => (
                        <div key={item._id} className="sg-item">
                            <div className="sg-item-main">
                                <span className="sg-item-name">{item.name}</span>
                                <span className="sg-item-location">
                                    <FiMapPin size={13} />
                                    {describeLocation(item.location)}
                                </span>
                            </div>
                            {!readOnly && (
                                <div className="sg-item-actions">
                                    <button type="button" className="sg-item-edit" title="Editar endereço do gerador" onClick={() => setEditingId(item._id)}>
                                        <FiMapPin size={16} />
                                    </button>
                                    <button type="button" className="sg-item-remove" title="Remover" onClick={() => removeItem(item)}>
                                        <FiX size={18} />
                                    </button>
                                </div>
                            )}
                        </div>
                    ))
                ) : (
                    <p className="sg-empty">Nenhum gerador vinculado</p>
                )}
            </div>

            <Modal
                modalStatus={modalGenerators}
                changeStatus={setModalGenerators}
                w={60}
                content={
                    <Generator
                        selectItem={true}
                        handleOnSelectItem={handleOnSelectItemGenerator}
                        selectedData={generators}
                        onFinishSelect={() => setModalGenerators(false)}
                    />
                }
            />

            <GeneratorLocationModal
                modalStatus={!!currentGenerator}
                generator={currentGenerator}
                client={data}
                initial={currentGenerator?.location}
                onConfirm={finishQuestion}
                onClose={dismissQuestion}
            />

        </section>
    )
}

export default SelectGenerators
